<div [@routerTransition]>
    <sub-header [title]="'VendorPayments' | localize" [description]="'VendorPaymentsHeaderInfo' | localize">
        <div role="actions">
            <div class="btn-group" dropdown placement="button right">
                <button
                    id="dropdownButtonExcelOperations"
                    dropdownToggle
                    type="button"
                    class="btn btn-outline btn-outline-success btn-active-light-success dropdown-toggle me-1"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-controls="dropdownMenuExcelOperations"
                >
                    <i class="far fa-file-excel btn-md-icon"></i>
                    <span class="d-none d-md-inline-block">
                        {{ 'ExcelOperations' | localize }}
                    </span>
                </button>
                <ul
                    id="dropdownMenuExcelOperations"
                    class="dropdown-menu dropdown-menu-right dropdown-excel-operations"
                    role="menu"
                    *dropdownMenu
                    aria-labelledby="dropdownButtonExcelOperations"
                >
                    <li role="menuitem">
                        <a
                            class="dropdown-item text-gray-900"
                            id="ExportVendorPaymentsToExcelButton"
                            (click)="this.showExcelColumnSelectionModal()"
                            href="javascript:;"
                        >
                            <i class="fa fa-download me-2 mt-1 text-gray-900" style="font-size: 1rem"></i>
                            {{ 'ExportToExcel' | localize }}
                        </a>
                    </li>

                    <li *ngIf="'Pages.VendorPayments.Create' | permission" role="menuitem">
                        <a href="javascript:;" class="no-padding">
                            <span class="fileinput-button">
                                <p-fileUpload
                                    mode="basic"
                                    customUpload="true"
                                    name="ExcelFileUpload"
                                    #ExcelFileUpload
                                    maxFileSize="10000000"
                                    auto="auto"
                                    accept=".csv,.xls,.xlsx"
                                    (uploadHandler)="uploadExcel($event)"
                                    (onError)="onUploadExcelError()"
                                    chooseLabel="{{ 'ImportFromExcel' | localize }}"
                                ></p-fileUpload>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>

            <button
                id="btn_create_VendorPayment"
                *ngIf="'Pages.VendorPayments.Create' | permission"
                (click)="createVendorPayment()"
                class="btn btn-primary blue"
            >
                <i class="fa fa-plus"></i>
                {{ l('CreateNewVendorPayment') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                               <form>
                    <div>
                        <div class="row">
                            <div class="col-md-3">
                                <select name="vendorId" [(ngModel)]="vendorId"
                                        (change)="getVendorPayments($event)"
                                        class="form-select">
                                    <option value="0">{{ l('SelectAVendor') }}</option>

                                    <option *ngFor="let item of allvendors" value="{{ item.id }}">
                                        {{ item.displayName }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="receiptNo"
                                                name="receiptNo"
                                                autoFocus
                                                type="text"
                                                class="form-control"
                                                [placeholder]="l('PaymentNo')" />
                                    </div>
                            </div>
                             <div class="col-md-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="invoiceNo"
                                                name="invoiceNo"
                                                autoFocus
                                                type="text"
                                                class="form-control"
                                                [placeholder]="l('InvoiceNo')" />
                                    </div>
                            </div>

                            <div class="col-md-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="referenceNo"
                                                name="referenceNo"
                                                autoFocus
                                                type="text"
                                                class="form-control"
                                                [placeholder]="l('ReferenceNo')" />
                                    </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label class="form-check form-check-custom form-check-solid">
                                    <input id="DateRange"
                                           #Product_IsActive="ngModel"
                                           name="DateRange"
                                           [(ngModel)]="dateRangeSelected"
                                           (click)="OnselectDateRange($event)"
                                           type="checkbox"
                                           class="form-check-input" />
                                    <span class="form-check-label">
                                        {{ l('DateRange') }}
                                    </span>
                                </label>
                            </div>
                            <div class="col-md-3" *ngIf="dateRangeSelected">
                                    <p-calendar [(ngModel)]="dateRange"
                                                selectionMode="range"
                                                dateFormat="yy-mm-dd"
                                                inputStyleClass="form-control">
                                    </p-calendar>
                            </div>
                            <div class="col-md-3">
                                        <select name="paymentTypeId" [(ngModel)]="paymentTypeId"
                                                (change)="getVendorPayments($event)"
                                                class="form-select">
                                            <option value="0">{{ l('SelectAPaymentType') }}</option>

                                            <option *ngFor="let item of allPaymentTypes" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                        </select>
                            </div>
                            <div class="col-md-3">
                                    <button class="btn btn-default btn-primary blue btn-sm" type="submit" (click)="getVendorPayments($event)">
                                        Refresh
                                    </button>
                                    &nbsp;&nbsp;&nbsp;
                                    <button id="btn-reset-filters" class="btn btn-secondary btn-sm" (click)="getVendorPayments($event)"> Reset </button>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table
                            #dataTable
                            (onLazyLoad)="getVendorPayments($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                            [paginator]="false"
                            tableStyleClass="table table-bordered table-hover"
                            [lazy]="true"
                            [scrollable]="true"
                            ScrollWidth="100%"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            [resizableColumns]="primengTableHelper.resizableColumns"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 130px"
                                        [hidden]="
                                            !isGrantedAny(
                                                'Pages.VendorPayments.Edit',
                                                'Pages.VendorPayments.Delete'
                                            )
                                        ">
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="receiptNo">
                                        {{ l('PaymentNo') }}
                                        <p-sortIcon field="vendorPayment.receiptNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="receiptDate">
                                        {{ l('PaymentDate') }}
                                        <p-sortIcon field="vendorPayment.receiptDate"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="VendorFk.displayProperty">
                                        {{ l('Vendor') }}
                                        <p-sortIcon field="VendorDisplayProperty"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="paymentTypeFk.name">
                                        {{ l('PaymentType') }}
                                        <p-sortIcon field="paymentTypeName"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="reference">
                                        {{ l('Reference') }}
                                        <p-sortIcon field="vendorPayment.reference"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="amount" class="text-center">
                                        {{ l('Amount') }}
                                        <p-sortIcon field="vendorPayment.amount"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="status" class="text-center">
                                        {{ l('Status') }}
                                        <p-sortIcon field="vendorPayment.status"></p-sortIcon>
                                    </th>

                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td style="width: 130px"
                                        [hidden]="
                                            !isGrantedAny(
                                                'Pages.VendorPayments.Edit',
                                                'Pages.VendorPayments.Delete'
                                            )
                                        ">
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                                {{ l('Actions') }}
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.VendorPayments.Edit') &&  record.vendorPayment.status != paymentStatus.Paid"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/purchase/vendorPayments/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.vendorPayment.id }">
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.VendorPayments.Edit') && record.vendorPayment.status == paymentStatus.Paid"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/purchase/vendorPayments/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.vendorPayment.id }">
                                                        {{ l('View') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.VendorPayments.Draft') && record.vendorPayment.status == paymentStatus.Paid"
                                                       (click)="convertToDraft(record.vendorPayment)">
                                                        {{ l('ConvertToDraft') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.VendorPayments.Payment') && record.vendorPayment.status == paymentStatus.UnPaid"
                                                       (click)="convertToPayment(record.vendorPayment)">
                                                        {{ l('ConvertToPayment') }}
                                                    </a>
                                                </li>
                                                <li *ngIf="record.vendorPayment.journalHeaderId">
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       (click)="printVoucher(record.vendorPayment.journalHeaderId)">
                                                        {{ l('PrintVoucher') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.VendorPayments.Delete')"
                                                       (click)="deleteVendorPayment(record.vendorPayment)">
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('ReceiptNo') }}</span>
                                        {{ record.vendorPayment.receiptNo }}
                                    </td>

                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('ReceiptDate') }}</span>

                                        <span *ngIf="record.vendorPayment.receiptDate">
                                            {{ record.vendorPayment.receiptDate | date }}
                                        </span>

                                        <span *ngIf="!record.vendorPayment.receiptDate">-</span>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_Name_Here}}')}}</span>
                                        {{ record.vendorDisplayProperty }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_Name_Here}}')}}</span>
                                        {{ record.paymentTypeName }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Reference') }}</span>
                                        {{ record.vendorPayment.reference }}
                                    </td>
                                    <td style="width: 150px;" class="text-end">
                                        <span class="p-column-title">{{ l('Amount') }}</span>
                                        {{ record.vendorPayment.amount }}
                                    </td>
                                    <td style="width: 150px" class="text-center">
                                        <span class="p-column-title">{{ l('Status') }}</span>
                                        <span class="badge" [ngClass]="utilsService.getPaymentStatusBadgeClass(record.vendorPayment.status)">
                                            {{ l(paymentStatus[record.vendorPayment.status]) }}
                                        </span>
                                    </td>

                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator
                                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                #paginator
                                (onPageChange)="getVendorPayments($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true"
                                [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "
                            ></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>

    <excel-column-selection-modal
        (modalSave)="exportToExcel($event)"
        #excelColumnSelectionModal
    ></excel-column-selection-modal>
</div>
